import { render, staticRenderFns } from "./FiltersPreview.vue?vue&type=template&id=122d1c40"
import script from "./FiltersPreview.vue?vue&type=script&lang=ts"
export * from "./FiltersPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports